import {useQuery} from "react-query";
import {QUERY_KEYS} from "../query-keys";
import {getNotice, getNotices} from "../../api/AlfyApiClient";
import {GetNoticesParam} from "../../models/notice";

export const useGetNotice = (id: string) => {
    return useQuery([QUERY_KEYS.NOTICE, id],
        async () => {
            return await getNotice(id)
        },
        {
            enabled: id.length > 0,
        })
}

export const useGetNotices = (getNoticesParam: GetNoticesParam) => {
    return useQuery([QUERY_KEYS.NOTICES, getNoticesParam],
        async () => {
            return await getNotices(getNoticesParam.page, getNoticesParam.pageSize)
        },
    )
}